import React from "react";
import _ from "lodash";
import { useIntl } from "react-intl";
import AbstractDropdown from "../../../shared/entity/components/AbstractFormField/fields/AbstractDropdown";

function TripColumnsSelector({ selectedColumns, trip = {}, onChange }) {
    const intl = useIntl();
    const excludedFields = [
        "tripActions",
        "creatorId",
        "creatorType",
        "tags",
        "currentTripPointId",
        "driverIdConfirmed",
        "truckIdConfirmed",
        "supplierIdConfirmed",
        "tagsCount",
    ];

    const columnsToDropdownOptions = (columns) =>
        columns
            .filter((column) => !excludedFields.includes(column.id))
            .map((column) => ({
                id: column.id,
                label: _.startCase(intl.formatMessage({ id: `trip-attr.${column.id}` })),
            }));

    const availableColumns = columnsToDropdownOptions(
        Object.keys(trip).map((tripAttribute) => ({
            id: tripAttribute,
            label: _.startCase(intl.formatMessage({ id: `trip-attr.${tripAttribute}` })),
        }))
    );

    return (
        <AbstractDropdown
            entityOptions={{ label: "Columns" }}
            onValueChange={(selectedOptions) => {
                onChange(selectedOptions);
            }}
            selectedOptions={columnsToDropdownOptions(selectedColumns)}
            options={availableColumns}
            isClearable={false}
            multipleSelection
        />
    );
}

export default TripColumnsSelector;
